import { createAction, props } from '@ngrx/store';
import { ISelectPlant } from 'src/app/pages/orders/delivery-schedule/components/filters-delivery-schedule/models/filters.model';

export const loadPlantsBySubgroup = createAction('[Plants By Subgroup] Load', props<{ subGroupId: number }>());

export const loadPlantsBySubgroupSuccess = createAction(
  '[Plants By Subgroup] Load Success',
  props<{ response: ISelectPlant[] }>(),
);

export const loadPlantsBySubgroupSuccessByKey = createAction(
  '[Plants By Subgroup] Load Success By Key',
  props<{ key: string; response: ISelectPlant[] }>(),
);

export const loadPlantsBySubgroupFailure = createAction('[Plants By Subgroup] Load Failure', props<{ error: any }>());
